<template>
  <div>
    <img class="img-fluid pb-3" v-bind:src="image.back" style="width:100%">
    <ValidationObserver v-slot="{ handleSubmit }" ref="mrz">
      <form id="mrzForm" autocomplete="off">
        <ValidationProvider name="MRZ" vid="mrz.type" v-slot="{ errors }">
          <select class="form-control" v-model="mrz.type" :class="{ 'is-invalid': errors[0] }" v-on:change="changeType" required>
            <option value="" disabled="" selected="">Select Document Type</option>
            <option value="td1">TD1 - IDs (3 x 30)</option>
            <option value="td2">TD2 - IDs (2 x 36)</option>
            <option value="td3">TD3 - Passports (2 x 44)</option>
          </select>
          <span class="text-danger">{{errors[0]}}</span>
        </ValidationProvider>

        <div v-if="mrz.type">
          <label for="mrz.code">Transcript the MRZ code from the image</label>

          <ValidationProvider name="MRZ code" vid="mrz" v-slot="{ errors }">
            <input class="form-control" id="code-1" name="code[]" v-on:input="input(0, $event)" v-on:keydown="keydown" v-on:blur="change(0, $event)" rows="1" v-bind:maxlength="mrz.length" autocomplete="off">
            <input class="form-control" id="code-2"  name="code[]" v-on:input="input(1, $event)" v-on:keydown="keydown" v-on:blur="change(1, $event)" rows="1" v-bind:maxlength="mrz.length" autocomplete="off">
            <input class="form-control" id="code-3" name="code[]" v-if="mrz.type == 'td1'" v-on:input="input(2, $event)" v-on:keydown="keydown" v-on:blur="change(2, $event)" rows="1" v-bind:maxlength="mrz.length" autocomplete="off">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>

          <!--<ValidationProvider name="MRZ code" vid="mrz.code" v-slot="{ errors }">
            <textarea class="form-control" v-model="mrz.code" rows="3" :class="{ 'is-invalid': errors[0] }" v-on:keydown="keydown" required></textarea>
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>-->

          <div class="d-flex justify-content-between w-100">
            <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
              <b-button v-b-modal.confirmDeleteModal type="button" name="save" class="btn btn-danger flex-grow-1" v-if="$route.params.guestId">Delete Guest</b-button>
              <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">Save Guest</button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import moment from 'moment';
moment.parseTwoDigitYear = function (yearString) {
  return parseInt(yearString) + (parseInt(yearString) > parseInt(moment().format("YY")) ? 1900 : 2000);
}

export default {
  name: 'GuestMRZ',
  props: ['guest', 'image', 'changeDOB', 'checkFields', 'setActive'],
  data: () => ({
    ctrlDown: false,
    mrz: {
      type: "",
      length: "",
    }
  }),
  created(){

  },
  methods: {
    submit(){
      let codes = document.getElementsByName('code[]');
      let mrz = "";
      codes.forEach(function(code){
        mrz += code.value + "\n";
      })
      fetch(process.env.VUE_APP_API + '/mrz/string', {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          mrz: mrz.trim()
        })
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        console.log(response)
        if(response.error){
          this.$refs.mrz.setErrors(response.error.messages);
        }else{
          this.guest.name.last = response.fields[0];
          this.guest.name.first = response.fields[1];
          this.guest.country = response.fields[3];
          this.guest.dob.year = Number(response.fields[4].substring(0,2)) ? moment(Number(response.fields[4].substring(0,2)), "YY").format("YYYY") : null;
          this.guest.dob.month = Number(response.fields[4].substring(2,4));
          this.guest.dob.day = Number(response.fields[4].substring(4,6));
          this.guest.gender = response.fields[6];
          this.guest.document.type = response.fields[7].replace("1", "I").substring(0,1);
          this.guest.document.number = response.fields[8];

          //this.changeDOB();
          this.setActive('fields');
          this.checkFields(response.failed);
        }
      })
    },
    changeType(event){
      if(this.mrz.type == 'td1'){
        this.mrz.length = 30;
      }else if(this.mrz.type == 'td2'){
        this.mrz.length = 36;
      }else if(this.mrz.type == 'td3'){
        this.mrz.length = 44
      }
    },
    change(index, event){
      console.log("changing")
      console.log(this.mrz.length)
      console.log(index)
      for(let i = event.target.value.length; i < this.mrz.length; i++){
        event.target.value += "<";
      }
      console.log(event.target.value)
    },
    input(index, event){
      console.log("inputing")
      let value = event.target.value;
      let position =  event.target.selectionStart;

      event.target.value = event.target.value.replace(/\s/gi, '<').replace(/[^\w<]/gi, '').toUpperCase().substring(0, this.mrz.length);
      event.target.setSelectionRange(position, position)
    },
    keydown(event){
      console.log(event)
      let keyCode = event.keyCode;
      let value = event.target.value;
      let position =  event.target.selectionStart;

      console.log(keyCode);
      if(keyCode == 13){
        event.preventDefault();
        if(position < value.length){
          console.log("Prelom vrstice je mogoč samo na koncu vstice")
          return;
        }
        event.target.nextElementSibling.focus()
      }
      return;


    }
  }
}
</script>
